import React from "react";
import { useDispatch } from "react-redux";
import { handleSidebar } from "Redux/features/MainSlice";
import profilavatar from "assets/images/face-1.jpg";

import { Row, Col, Breadcrumb, Avatar, Button } from "antd";
import { toggler } from "utils/HeaderData";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { ACCESS_NAME } from "helpers/constant";

export default function AntdHeader({ name }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { logout, login } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const names = name.split("/");

  const user = localStorage.getItem(ACCESS_NAME);

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Pages</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {names[0]}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {names[1]?.replace("-", " ") || names[0]?.replace("-", " ")}
            </span>
          </div>
        </Col>
        <Col span={24} md={18} className="header-control">
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => dispatch(handleSidebar())}
          >
            {toggler}
          </Button>
          <Button danger type="text" onClick={handleLogout}>
            Logout
          </Button>
          <Avatar
            style={{ backgroundColor: "#f56a00", verticalAlign: "middle" }}
            size={30}
            shape="circle"
            gap={4}
          >
            {user[0].toLocaleUpperCase()}
          </Avatar>
        </Col>
      </Row>
    </>
  );
}
